import React from 'react';
import PropTypes from 'prop-types';

const HighlightOptionValue = props => {
  const optionStyle = {
    borderRadius: 3,
    display: 'inline-block',
    marginRight: 10,
    position: 'relative',
    top: -2,
    verticalAlign: 'middle',
    width: '20px',
  };

  const highestIndexStyle = {
    borderRadius: 3,
    display: 'inline-block',
    marginRight: 15,
    position: 'relative',
    top: -2,
    verticalAlign: 'middle',
    width: '15px',
  };


  return (
    <div className="Select-value" title={props.value.label}>
      <span className="Select-value-label">
        <img
          src={props.value.selectedIcon}
          style={(props.value.label === 'Highest Index') ? highestIndexStyle : optionStyle}
          alt={props.value.title}
        />
        {props.children}
      </span>
    </div>
  );
};

HighlightOptionValue.propTypes = {
  children: PropTypes.node,
  // placeholder: PropTypes.string,
  value: PropTypes.shape({
    title: PropTypes.string,
    selectedIcon: PropTypes.string,
    label: PropTypes.string,
  }),
};

export default HighlightOptionValue;
